import React from "react";
import {
    Dialog,
    IconButton,
    makeStyles,
    Button,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import TrashIconWhite from "../../images/trash-icon-white.svg";

const useStyles = makeStyles(() => ({
    dialogPaper: {
        borderRadius: "20px",
        padding: "30px 30px 40px 30px",
        maxWidth: "450px",
        width: "450px",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        boxSizing: "border-box",
    },
    closeButton: {
        position: "absolute",
        top: "8px",
        right: "8px",
        backgroundColor: "#ED1C24",
        color: "#FFFFFF",
        width: "30px",
        height: "30px",
        padding: 0,
        borderRadius: "100px",
        zIndex: 1,
        boxShadow: "0px 2px 4px rgba(0,0,0,0.15)",
        "&:hover": {
            backgroundColor: "#D41920",
        },
    },
    iconCircle: {
        width: "80px",
        height: "80px",
        borderRadius: "50%",
        backgroundColor: "#ED1C24",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: "16px",
    },
    trashIcon: {
        width: "40px",
        height: "40px",
        filter: "brightness(0) invert(1)",
    },
    title: {
        fontSize: "24px",
        fontWeight: 700,
        fontFamily: "DM Sans, sans-serif",
        color: "#000000",
        marginBottom: "12px",
    },
    confirmText: {
        fontSize: "16px",
        fontWeight: 400,
        fontFamily: "DM Sans, sans-serif",
        color: "#000000",
        marginBottom: "8px",
        lineHeight: "150%",
    },
    description: {
        fontSize: "14px",
        fontWeight: 400,
        fontFamily: "DM Sans, sans-serif",
        color: "#000000",
        marginBottom: "24px",
        lineHeight: "150%",
        maxWidth: "360px",
    },
    deleteButton: {
        display: "flex",
        flexDirection: "row" as const,
        alignItems: "center",
        padding: "10px 40px",
        gap: "8px",
        background: "#ED1C24",
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        borderRadius: "10px",
        border: "none",
        fontFamily: "DM Sans, sans-serif",
        fontWeight: 600,
        fontSize: "18px",
        lineHeight: "1",
        color: "#FFFFFF",
        textTransform: "uppercase" as const,
        whiteSpace: "nowrap" as const,
        "&:hover": {
            background: "#D41920",
        },
    },
    deleteButtonIcon: {
        width: "20px",
        height: "20px",
        filter: "brightness(0) invert(1)",
    },
}));

interface ConfirmDeleteDialogProps {
    open: boolean;
    onClose: () => void;
    onDelete: () => void;
    title?: string;
    confirmText?: string;
    description?: string;
    buttonLabel?: string;
}

const ConfirmDeleteDialog: React.FC<ConfirmDeleteDialogProps> = ({
    open,
    onClose,
    onDelete,
    title = "Delete",
    confirmText = "Are you sure?",
    description = "This action cannot be undone.",
    buttonLabel = "DELETE",
}) => {
    const classes = useStyles();

    const handleDelete = () => {
        onDelete();
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} classes={{ paper: classes.dialogPaper }}>
            <IconButton className={classes.closeButton} onClick={onClose}>
                <CloseIcon style={{ fontSize: "18px" }} />
            </IconButton>

            <div className={classes.iconCircle}>
                <img src={TrashIconWhite} className={classes.trashIcon} alt="" />
            </div>

            <div className={classes.title}>
                {title}
            </div>

            <div className={classes.confirmText}>
                {confirmText}
            </div>

            <div className={classes.description}>
                {description}
            </div>

            <Button
                className={classes.deleteButton}
                startIcon={<img src={TrashIconWhite} className={classes.deleteButtonIcon} alt="" />}
                onClick={handleDelete}
            >
                {buttonLabel}
            </Button>
        </Dialog>
    );
};

export default ConfirmDeleteDialog;
